// extracted by mini-css-extract-plugin
export var menuIcon = "_iu-0";
export var menuIconInline = "_iu-1";